define( [
	"../../core"
], function( jQuery ) {

/**
 * Determines whether an object can have data
 */
return function( elem ) {
	var noData = jQuery.noData[ ( elem.nodeName + " " ).toLowerCase() ],
		nodeType = +elem.nodeType || 1;

	// Do not set data on non-element DOM nodes because it will not be cleared (#8335).
	return nodeType !== 1 && nodeType !== 9 ?
		false :

		// Nodes accept data unless otherwise specified; rejection can be conditional
		!noData || noData !== true && elem.getAttribute( "classid" ) === noData;
};

} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/data/var/acceptData.js
// module id = 264
// module chunks = 1